<template>
  <div class="diagnosis">
    <div class="vld-parent">
      <loading :active.sync="isLoading" :is-full-page="true"></loading>
    </div>
    <div>
      <form action="/diagnosis" method="post" @submit.prevent="submit" class="my-3" id="form-title">
      <transition name="slide-fade">
        <grid-question v-if="question && question.component == 'grid-question'" :key="question.id" />
        <text-question v-if="question && question.component == 'text-question'" :key="question.id" />
        <search-question v-if="question && question.component == 'search-question'" :key="question.id" />
        <free-text-question v-if="question && question.component == 'free-text-question'" :key="question.id" />
        <input-text-question v-if="question && question.component == 'input-text-question'" :key="question.id" />
        <brand-question v-if="question && question.component == 'brand-question'" :key="question.id" />
        <serial-text-question v-if="question && question.component == 'serial-text-question'" :key="question.id" />
        <reference-text-question v-if="question && question.component == 'reference-text-question'" :key="question.id" />
        <image-question v-if="question && question.component == 'image-question'" :key="question.id" />
      </transition>

      <div v-if="question.config && question.config.max > 1" class="option-count">
        <p v-if="Math.min(question.config.max, question.config.options.length) === 1">
          Sie können eine Antwort auswählen.
        </p>
        <p v-else>
          Eine Mehrfachauswahl ist möglich
        </p>
      </div>

      <div class="form-buttons nav-control" id="button-wrapper" v-if="afterLoad">
        <button type="button" class="btn btn-outline-secondary mt-3 shadow-none" id="backwards-button"
          @click="previousQuestion">
          Zurück
        </button>

        <span v-if="question.selectedAnswers">
          <button type="submit" class="btn btn-primary mt-3 shadow-none" id="submit-button"
            :disabled="question.selectedAnswers.length === 0" v-on:keydown.enter.prevent='submit' @mousedown.prevent>
            Weiter
          </button>
        </span>

      </div>
    </form>
    </div>
  </div>
</template>

<script>
import GridQuestion from './GridQuestion'
import TextQuestion from './TextQuestion'
import SearchQuestion from './SearchQuestion'
import FreeTextQuestion from './FreeTextQuestion'
import BrandQuestion from './BrandQuestion';
import InputTextQuestion from './InputTextQuestion';
import SerialTextQuestion from './SerialQuestion';
import ReferenceTextQuestion from './ReferenceQuestion';
import ImageQuestion from './ImageQuestion'

import Loading from 'vue-loading-overlay';
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: 'Diagnosis',
  components: {
    GridQuestion,
    TextQuestion,
    SearchQuestion,
    FreeTextQuestion,
    BrandQuestion,
    InputTextQuestion,
    SerialTextQuestion,
    ReferenceTextQuestion,
    ImageQuestion,
    Loading
  },
  computed: {
    question: function () {
      return this.$store.state.questions[0] || false
    },
    questionLength: function () {
      return this.$store.state.questions.length
    },
    afterLoad: {
      get() {
        return this.$store.state.afterLoad;
      },
      set(value) {
        this.$store.commit("setAfterLoad", value);
      }
    }
  },
  data() {
    return {
      isLoading: false,
      ilg: ['Cerruti 1881', 'Swiss Military Hanowa', 'Police', 'Timberland', 'Ducati Corse', 'Aigner', 'Hanowa']
    }
  },
  mounted() {
    if (!this.questionLength) {
      this.nextQuestion()
    }
  },
  methods: {
    previousQuestion() {
      if (this.$store.state.questions.length === 1) {
        this.$router.push({ name: 'Landingpage' })
        .catch(error=>{
          console.log(error);
        });
      } else {
        this.$store.state.questions.shift()
      }
    },
    nextQuestion() {
      this.isLoading = true;
      let data = {}

      if (this.question) {
        data = {
          question: this.question.id,
          answer: [],
          diagnosis: this.question.diagnosis
        }

        if (this.question.component == 'free-text-question' || 
        this.question.component == 'input-text-question' || 
        this.question.component == 'serial-text-question' || 
        this.question.component == 'reference-text-question') {
          let option = this.question.config.options.find(x => x.value === this.question.selectedAnswers.answer);
          data.answer.push(
            {
              question: this.question.intro,
              answer: this.question.selectedAnswers.answer,
              displayValue: this.question.selectedAnswers.displayValue,
              freeText: true,
              manualAdjustmentNecessary: option.manualAdjustmentNecessary
            }
          );
        }
        else {
          if (typeof (this.question.selectedAnswers) === 'string') {

            let option = this.question.config.options.find(x => x.value === this.question.selectedAnswers);
            if(this.ilg.includes(option.title)){
              location.replace('https://service.christ.de/ilg/')
              return;
            }
            data.answer.push({
              question: this.question.intro,
              answer: this.question.selectedAnswers,
              displayValue: option.title,
              freeText: false,
              manualAdjustmentNecessary: option.manualAdjustmentNecessary
            });
          }
          else {
            this.question.selectedAnswers.forEach(element => {
              let option = this.question.config.options.find(x => x.value === element);
              data.answer.push({
                question: this.question.intro,
                answer: element,
                displayValue: option.title,
                freeText: false,
                manualAdjustmentNecessary: option.manualAdjustmentNecessary
              });
            });
          }
        }
      }

      axios
        .post(process.env.VUE_APP_DABURL + 'api/diagnosis', data)
        .then((response) => {
          if (this.afterLoad == false) {
            this.$store.commit('setAfterLoad', true);
          }
          if (response.data.services) {
            this.$store.commit('setOverview', response.data.overview);
            this.$store.commit('setRepairServices', response.data.services);
            this.$router.push({ name: 'Cart' })
            .catch(error=>{
              console.log(error);
            });
          } else if (response.data.question) {
            const question = response.data.question
            question.selectedAnswers = []
            this.$store.commit('addQuestion', question)
          }
          this.isLoading = false;
        })
        .catch((error) => {
          if (this.afterLoad == false) {
            this.$store.commit('setAfterLoad', true);
          }
          // no variable and handling?
          // this.errors.push(error)
          this.isLoading = false;

        })

    },
    submit() {
      this.nextQuestion()
    }
  }
}
</script>
